import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
// Пауза после ввода, после которой применяется поиск "содержит".
const CONTAINS_DEBOUNCE_MS = 500;
export const ColumnFilter = ({ options, value, onApply }) => {
    const [inputValue, setInputValue] = useState(value);
    // Введённый вручную текст, ожидающий применения.
    const [typedValue, setTypedValue] = useState();
    // Внешний сброс/смена фильтра. Сравниваем с trim, чтобы не съедать пробел, который пользователь ещё печатает.
    useEffect(() => {
        setInputValue((prev) => (prev.trim() === value ? prev : value));
    }, [value]);
    useEffect(() => {
        if (typedValue === undefined) {
            return undefined;
        }
        const timer = setTimeout(() => {
            setTypedValue(undefined);
            onApply(typedValue.trim(), false);
        }, CONTAINS_DEBOUNCE_MS);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typedValue]);
    const apply = (nextValue, isOption) => {
        setTypedValue(undefined);
        onApply(nextValue.trim(), isOption);
    };
    return (React.createElement(Autocomplete, { freeSolo: true, size: "small", options: options, 
        // value не контролируем: текст в поле целиком определяется inputValue.
        value: null, inputValue: inputValue, onInputChange: (_event, nextValue, reason) => {
            setInputValue(nextValue);
            if (reason === 'input') {
                setTypedValue(nextValue);
            }
            else if (reason === 'clear') {
                // Крестик. onChange при этом не вызывается: value всегда null, и Autocomplete
                // не видит изменения (null -> null).
                apply('', false);
            }
        }, onChange: (_event, nextValue, reason) => {
            if (reason === 'select-option') {
                apply(nextValue ?? '', true);
            }
            else if (reason === 'create-option') {
                // Enter в поле - применить поиск "содержит" без ожидания паузы.
                apply(nextValue ?? '', false);
            }
        }, renderInput: (params) => React.createElement(TextField, Object.assign({}, params, { variant: "outlined", placeholder: "\u0412\u0441\u0435" })) }));
};
